import { Chip } from "@mui/material";
import { WorkOrderPoStatusEnum } from "commons/enum/work-order-po-status";
import { ICatalogueProperties } from "mobx-stores/_models/base";
type WorkOrderPoStatusProps = {
  status: ICatalogueProperties;
  isCompensating?: boolean;
};
export const WorkOrderPoStatus = ({
  status,
  isCompensating,
}: WorkOrderPoStatusProps) => {
  return (
    <Chip
      variant="filled"
      color={
        status.code === WorkOrderPoStatusEnum.Completed
          ? "success"
          : status.code === WorkOrderPoStatusEnum.Canceled
            ? "error"
            : "default"
      }
      label={`${status?.name}${isCompensating ? " (Bù hàng)" : ""}` || ""}
    ></Chip>
  );
};
